import {Component, ElementRef, Input, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ListSearchParams} from '../../shared/Models/listsearchparams.model';
import {ListComponent} from '../../iwgcommon/list/list.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Utils} from '../../shared/utils/utils';
import {UserService} from '../../shared/services/user.service';
import {NavbarService} from '../../shared/services/navbar.service';
import {GlobalConstants} from '../../iwgcommon/global-constants';
import {DocumentsService} from '../../shared/services/documents.service';
import { MatTableDataSource } from '@angular/material/table';
import { AssigmentdocumentDialogComponent } from '../assigmentdocument-dialog/assigmentdocument-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { catchError,debounceTime } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
import { CsvDataService } from 'src/app/shared/services/csv-export.service';
import { IWGSharedService } from '../../shared/services/shared.service';
@Component({
  selector: 'app-assigmentdetail-document',
  templateUrl: './assigmentdetail-document.component.html',
  styleUrls: ['./assigmentdetail-document.component.scss']
})
export class AssigmentdetailDocumentComponent implements OnInit {
  state: any;
  selectedSummaryItem:any;
  loading=false;
  allowEndClients = false;
  USEORDisabled = false;
  selectedService = 1;
  USComplianceDisabled = false;
  USAORDisabled = false;
  InternationalEORDisabled = false;
  InternationalComplianceDisabled = false;
  InternationalAORDisabled = false;
  ShowEngageButton = false;
  showCompliance = false;
  labelSingular = '';
  AssignmentGUID: any;
  @Input()AssignmentId: any;
  @Input()ContractorName: any;
  globalScopes: any;
  @Input()BussinessName: any;
  documentsId: any;
  @Input()AssignmentStatusId: any;
  @Input()AssignmentDisplayId:any;
  hideColsInExport: number[];
  lastColIndex = 12;
  pagination:any;
  dataSource:any;
  summary1:any=[];
  displayedColumns: string[] = [];
  pageEvent: PageEvent;
  @ViewChild('wrapper1') wrapper1: ElementRef<any>;
  @ViewChild('wrapper2') wrapper2: ElementRef<any>;

  @ViewChild('div1') div1: ElementRef<any>;
  @ViewChild('div2') div2: ElementRef<any>;
  @ViewChild('listTable') listTable: any;
  @ViewChild(MatSort) sort: MatSort;
 
  listColumns: string[];
  items:any=[];
  totalRecords:any;
  fileName = '';
  isEmbed = false;
  exportColDetails: any;
  constructor(private router: Router, utils: Utils, public userService: UserService,
              public nav: NavbarService, private renderer: Renderer2, public route: ActivatedRoute,
              public documentsService: DocumentsService, private zone: NgZone,public dialog: MatDialog,
              private csvDataService: CsvDataService, private sharedService:IWGSharedService) {
    this.globalScopes = GlobalConstants.globalScopes;
  }
  ngOnInit(): void {
    this.listColumns = ['DocumentID', 'DocumentType', 'DocumentName', 'Notes', 'DateReceived', 'DateIssued','ExpirationDate',  'Upload', 'Download','DoesNotHave','UploadedBy',
    'Status', 'OprMenu'];
    this.isEmbed = this.sharedService.getIsEmbed();
    this.displayedColumns = [...this.listColumns];
    this.state = {limit: 25, page: 1, service: 1, global_scope: 1, country: -1};
    this.allowEndClients = this.userService.getAllowEndClients();
    this.route.queryParams.subscribe(params => {
      this.documentsId = params.ID;
      if (params) {
        this.selectedService = +params.service;

        this.state = Object.assign({}, this.state, (params));
        if (!this.state.service) {
          this.state.service = 1;
        }
        if (params.start) {
          this.state.start = new Date(params.start);
        }
        if (params.end) {
          this.state.end = new Date(params.end);
        }
        this.generateListColumns()
        this.getItems()
        this.exportColDetails = {
          'DocumentID': {'heading': 'Document ID', 'dataFieldName': 'DocumentID'}, 
          'DocumentType': {'heading': 'Document Type', 'dataFieldName': 'DocumentTypeName'}, 
          'DocumentName': {'heading': 'Document Name', 'dataFieldName': 'DocumentName'}, 
          'Notes': {'heading': 'Notes', 'dataFieldName': 'Notes'},  
          'DateReceived': {'heading': 'Date Received', 'dataFieldName': 'ReceivedDate', 'dataFormat': 'date'},               
          'DateIssued': {'heading': 'Date Issued', 'dataFieldName': 'IssuedDate', 'dataFormat': 'date'}, 
          'ExpirationDate': {'heading': 'Expiration Date', 'dataFieldName': 'ExpireDate', 'dataFormat': 'date'}, 
          'UploadedBy': {'heading': 'Uploaded By', 'dataFieldName': 'UploadedByName'}, 
          'Status': {'heading': 'Status', 'dataFieldName': 'StatusName'},
        }
        this.fileName = 'MyVista_Evaluations_Export.csv';
      }

    });
  }
  
  downloadAllForDocument(documentId)  {
    if (documentId && documentId !== 0) {
        var origin = window.location.origin;
        window.location.href = origin + '/Assignment/DownloadAllForDocument?documentID=' + documentId;
    }
}
changeToDoesNotHave(ev, evaluationDocumentTypeID, documentTypeID) {  
  var isConfirmed = confirm('Please confirm the status of the document should be changed to “Does Not Have”. Once the status is changed to “Does Not Have” you will not be able to upload a document.');
  if (isConfirmed) {
      this.UpdateStatus(evaluationDocumentTypeID, 4, false, documentTypeID);
  } else {
      return false;
  }
}
UpdateStatus(evaluationDocumentTypeID, newStatusID, isArchive, documentTypeID) {
 this.loading = true;
  let props = {
      assignment_id: this.AssignmentId,
      assignment_display_id: this.AssignmentDisplayId,
      document_type_id: documentTypeID,
      new_status_id: newStatusID,
      limit: this.state.limit,
      page: this.state.page,
      status: this.selectedSummaryItem.FilterValue
  };
  if (!evaluationDocumentTypeID) { //Set to zero if there is no eval document type
      evaluationDocumentTypeID = 0;
  }
  return this.documentsService.changeStatus(evaluationDocumentTypeID,props)
  .subscribe((response:any)=>
  {
    if (response.data.Data.RequestSuccess==false)
     {
      this.onSaveError(response);
    }else{
      this.onSaveSuccess(response);
    }  
    
  });
}
generateListColumns(){
  this.displayedColumns = [...this.listColumns];
  this.hideColsInExport = [9, 10,11,12]
}
onSaveSuccess(response) {
  this.loading = false;
  if (response.data.Data.RequestSuccess==false) {
      console.error(response);
  } else {
      var res = response.data.Data;
    
      this.summary1 = response.data.Data.Summary.SummaryItems;
     
      if (response.data.Data.Summary) {
        this.summary1 = response.data.Data.Summary.SummaryItems;

       
        if (!this.selectedSummaryItem && this.summary1) {
            this.selectedSummaryItem = this.summary1[0];
        }
    }
      if (res)
      {
          if (res.assignmentStatusId === 15) {
             
             
             this.sharedService.assignmentStatusChange.next(true); 
              alert('Thank you for submitting all required documentation.');
          } else {
            
          
            this.items = response.data.Data.objects;
    
         
            this.dataSource = new MatTableDataSource<any>(this.items);
            this.pagination = {
                total: response.data.Data.total
            };

            if (response.data.Data.Summary) {
                this.summary1 = response.data.Data.Summary.SummaryItems;

               
                if (!this.selectedSummaryItem && this.summary1) {
                    this.selectedSummaryItem = this.summary1[0];
                }
            }
          }
      }
  }
 }
    onSaveError(error) { 
  this.loading = false;
  console.error(error);
}
DownloadAllAttachments(){
  var isHavingAnyDocuments = false;  
            this.items.forEach(function (item, key) {
                if (item.DocumentFileIDs) {
                    isHavingAnyDocuments = true;
                    return false;
                }
            });
            if (isHavingAnyDocuments) {
                var origin = window.location.origin;
                window.location.href = origin + '/Assignment/DownloadAllAttachmentFromClientPortal?assignemntID=' + this.AssignmentDisplayId;
            } else {
                alert('There is no file(s) to download.');
            }
}
showDocumentDialog = (ev, evaluationDocumentTypeID, documentTypeID, documentTypeName) => {
  if (evaluationDocumentTypeID) {
  this.documentsService.getDocumentsId(evaluationDocumentTypeID).pipe(catchError((err) => {
    console.log('There was an error getting data in component', err);
    throw (err);
})).subscribe(Document => { 
  this.show(ev, Document.data.Data, evaluationDocumentTypeID, documentTypeID, documentTypeName, this.AssignmentDisplayId, this.ContractorName, this.BussinessName)
});
  }else{
    this.show(ev, null, null, documentTypeID, documentTypeName, this.AssignmentDisplayId, this.ContractorName, this.BussinessName)
  }
};

show(ev, Document, evaluationDocumentTypeID, documentTypeID, documentTypeName, assignmentId, contractorName, bussinessName){
  this.sharedService.isBlurredBg.next(true);
  const dialogRef = this.dialog.open(AssigmentdocumentDialogComponent, {
    panelClass: ['iwg-form-dialogfull'], maxWidth:"100%",
    data: {existingDocument:Document,evaluationDocumentTypeID:evaluationDocumentTypeID,documentTypeID:documentTypeID,documentTypeName:documentTypeName,AssignmentId:assignmentId,ContractorName:contractorName,BussinessName:bussinessName}
   });
  dialogRef.afterClosed().subscribe( result => {
      this.getItems();
      this.sharedService.isBlurredBg.next(false);    
  });
}
sortData(sort: Sort): void {
  const isAsc = sort.direction === 'asc';
  this.state.order_by = sort.active;
  this.state.order = sort.direction;
  this.getItems();
}
handleDateChange(date): void {
}
getItems(){
  const datePipe = new DatePipe('en-US');
  let props = {
    assignment_id: this.AssignmentId,
    assignment_display_id: this.AssignmentDisplayId,
    limit: this.state.limit,
    page: this.state.page,
    start: datePipe.transform(this.state.start, 'yyyy-MM-dd'),
    end: datePipe.transform(this.state.end, 'yyyy-MM-dd'),
    global_scope: 1,
    order: this.state.order,
    order_by:this.state.order_by,
    service: 3,
    status: this.selectedSummaryItem?this.selectedSummaryItem.FilterValue:null
};
this.loading=true;
  this.documentsService.getItems(props).pipe(catchError((err) => {
    console.log('There was an error getting data in component', err);
    throw (err);
}))
    .subscribe(response => {
      this.loading = false;
      if (response.data.RequestSuccess==false) {
          console.error(response);
      } else {
          var res = response.data.Data;
          this.totalRecords = response.data.Data.total;
         
          this.summary1 = response.data.Data.Summary.SummaryItems;         
          if (response.data.Data.Summary) {
            this.summary1 = response.data.Data.Summary.SummaryItems;
    
          
            if (!this.selectedSummaryItem && this.summary1) {
                this.selectedSummaryItem = this.summary1[0];
            }
        }
          if (res)
          {            
               
                  this.items = response.data.Data.objects;
    
                 
                  this.dataSource = new MatTableDataSource<any>(this.items);
                  this.pagination = {
                      total: response.data.Data.total
                  };
    
                  if (response.data.Data.Summary) {
                      this.summary1 = response.data.Data.Summary.SummaryItems;
    
                    
                      if (!this.selectedSummaryItem && this.summary1) {
                          this.selectedSummaryItem = this.summary1[0];
                      }
                  }
              
          }
      }
      
    },
        error => {
            this.loading = false;
            console.log(error);
        });
}
changeSummary(summaryItem): void {
  this.selectedSummaryItem = summaryItem;
  this.getItems();
}
naviatePageTo(event?: PageEvent): void {
  this.state.page = event.pageIndex + 1;
  this.state.limit = event.pageSize;
  this.getItems();
}
archieveDocument = (ev, evaluationDocumentTypeID, documentTypeID) => {
  this.UpdateStatus(evaluationDocumentTypeID, 6, true, documentTypeID);
};
unArchieveDocument = (ev, evaluationDocumentTypeID, documentTypeID) => {
  this.UpdateStatus(evaluationDocumentTypeID, 1, false, documentTypeID);
};

setTopScroll(): void {
  this.zone.onStable.pipe(debounceTime(300)).subscribe(() => {
    this.renderer.setStyle(this.div1.nativeElement, 'width', (this.listTable._elementRef.nativeElement.clientWidth) + 'px');
    this.wrapper1.nativeElement.onscroll = e => {
      this.renderer.setStyle(this.div1.nativeElement, 'width', (this.listTable._elementRef.nativeElement.clientWidth ) + 'px');
      this.wrapper2.nativeElement.scroll((e.target as HTMLElement).scrollLeft, 0);
    }
    this.wrapper2.nativeElement.onscroll = e => {
      this.renderer.setStyle(this.div1.nativeElement, 'width', (this.listTable._elementRef.nativeElement.clientWidth ) + 'px');
      this.wrapper1.nativeElement.scroll((e.target as HTMLElement).scrollLeft, 0);
    };
  });
}

ngAfterViewInit(): void {
  this.setTopScroll();
}
exportTable () {
  let exportColList = [];
  exportColList.push('DocumentID','DocumentType','DocumentName', 'Notes', 'DateReceived', 
      'DateIssued', 'ExpirationDate', 'UploadedBy', 'Status');
  this.csvDataService.exportToCsv(this.fileName, this.items, this.exportColDetails, exportColList);
}
}
